import { CastButton as CastButton$1 } from "../../../../../ui/cast-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/default/cast-enter.js";
import ForwardRef$1 from "../../../../../icons/dist/react/default/cast-exit.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/default-live-video/components/buttons/cast-button.tsx
/** @jsxImportSource react */
function CastButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(CastButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-cast-button", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-cast-button-enter-icon") }), /* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-cast-button-exit-icon") })]
	});
}
//#endregion
export { CastButton };

//# sourceMappingURL=cast-button.js.map